export default {
  loading: 0,
  systemInfo: {},
  linkUrl: '',
  device: 'desktop',
  hotGame: [],
  indexGame: [],
  allGame: {},
  bannerList: {},
  bulletinContent: '',
  qiniuUrl: ''
  // allGameAttrs: {}
};



// WEBPACK FOOTER //
// ./src/store/state.js